export const ListQueryKey = 'projectCates';
export const DetailQueryKey = 'projectCate';
export const Urls = {
  selectUrl: '/projectcate/list',
  updateUrl: '/projectcate/update',
  deleteUrl: '/projectcate/delete',
  createUrl: '/projectcate/create',
  detailUrl: '/projectcate/detail'
};